module.exports = __webpack_public_path__ + "dca60bb3f539347941e6835a5b41bd73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ua-logo.png
// module id = 1854
// module chunks = 1